import posthog from 'posthog-js';
import { track as vercelTrack } from '@vercel/analytics';

function isDestEnabled(name) {
  try {
    const dest = process.env.REACT_APP_ANALYTICS_DEST || 'posthog,vercel';
    return dest.split(',').map(s => s.trim().toLowerCase()).includes(name);
  } catch (_) {
    return true;
  }
}

export function identify(userId, traits = {}) {
  // Avoid sending PII; userId should be a hash or opaque ID
  if (isDestEnabled('posthog')) {
    try {
      if (userId) {
        posthog.identify(String(userId), traits);
        // Attach groups if provided
        if (traits && traits.school_name) {
          try { posthog.group('school', String(traits.school_name).toLowerCase(), { school_name: traits.school_name }); } catch (_) {}
        }
        // Single class name
        if (traits && traits.class_name) {
          try { posthog.group('class', String(traits.class_name).toLowerCase(), { class_name: traits.class_name }); } catch (_) {}
        }
        // Multiple classes array: traits.classes or traits.class_names
        try {
          const classes = Array.isArray(traits?.classes) ? traits.classes : (Array.isArray(traits?.class_names) ? traits.class_names : []);
          classes.forEach((cn) => {
            if (!cn) return;
            try { posthog.group('class', String(cn).toLowerCase(), { class_name: cn }); } catch (_) {}
          });
        } catch (_) {}
        // Persist initial UTM once
        try {
          const stored = localStorage.getItem('ph_initial_utm');
          if (!stored) {
            const params = new URLSearchParams(window.location.search);
            const utm = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'].reduce((acc, k) => {
              const v = params.get(k);
              if (v) acc[`$initial_${k}`] = v;
              return acc;
            }, {});
            if (Object.keys(utm).length) {
              localStorage.setItem('ph_initial_utm', JSON.stringify(utm));
              posthog.people && posthog.people.set && posthog.people.set(utm);
            }
          }
        } catch (_) {}
      } else posthog.reset();
    } catch (_) {}
  }
  // Vercel analytics does not support identify; skip
}

export function setUserProps(props = {}) {
  if (isDestEnabled('posthog')) {
    try { posthog.people && posthog.people.set && posthog.people.set(props); } catch (_) {}
  }
}

export function track(event, props = {}) {
  if (isDestEnabled('posthog')) {
    try { posthog.capture(event, props); } catch (_) {}
  }
  if (isDestEnabled('vercel')) {
    try { vercelTrack(event, props); } catch (_) {}
  }
}

export function page(route, props = {}) {
  if (isDestEnabled('posthog')) {
    try { posthog.capture('$pageview', { route, ...props }); } catch (_) {}
  }
  if (isDestEnabled('vercel')) {
    try { vercelTrack('page_view', { route, ...props }); } catch (_) {}
  }
}

export function shutdownAnalytics() {
  try { posthog.reset(); } catch (_) {}
}


